export default {"src":"/_next/static/media/discover-daycations.9f83b39e.svg","height":48,"width":56};